import { RouteObject } from 'react-router-dom';
import authRoutes from './auth';

const routes: RouteObject[] = [...authRoutes];

export default routes;
